import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess, staticc } from "../../Components/General/Notification";

const delelte = (type) => {
    return ({
        type: type
    })
}
const addVendor = () => {
    return ({
        type: types.ADD_VENDOR
    })
}

const editVendor = () => {
    return ({
        type: types.EDIT_VENDOR
    })
}

const getVendors = (vendors) => {
    return ({
        type: types.GET_ALL_VENDORS,
        payload: vendors
    })
}

const editStatueVendor = () => {
    return ({
        type: types.EDIT_STATUS_VENDORS
    })
}

const getOneVendor = (oneVendor) => {
    return ({
        type: types.GET_ONE_VENDORS,
        payload: oneVendor
    })
}

const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}



export const postVendor = (name, name_ar, description, description_ar, phone, phone1, email, address, address1, start_date,
    expire_date, image, custom_date, subcategories, latitude, longitude, days, social_media, category_id, setloadBtn
) => {
    return function (dispatch) {
        setloadBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('description', description);
        Dataa.append('description_ar', description_ar);
        Dataa.append('phone', phone);
        Dataa.append('phone1', phone1);
        Dataa.append('email', email);
        Dataa.append('address', address);
        Dataa.append('address1', address1);
        Dataa.append('start_date', start_date);
        Dataa.append('expire_date', expire_date);
        Dataa.append('image', image);
        Dataa.append('custom_date', custom_date);
        Dataa.append('latitude', latitude);
        Dataa.append('longitude', longitude);
        Dataa.append('category_id', category_id);
        for (var i = 0; i < subcategories.length; i++) {
            Dataa.append(`subcategories[${i}]`, subcategories[i]);
        }
        days.forEach((field, index) => {
            Dataa.append(`days[${index}][day_id]`, field.dayId);
            Dataa.append(`days[${index}][open_at]`, field.openAt);
            Dataa.append(`days[${index}][close_at]`, field.closeAt);
        });
        social_media.forEach((field, index) => {
            Dataa.append(`social_media[${index}][id]`, field.socId);
            Dataa.append(`social_media[${index}][link]`, field.link);
        });
        axios.post(`${staticc}/api/vendor_add`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message === "success") {
                dispatch(addVendor());
                dispatch(loadVendors());
                notifysuccess(res.data.message)
                setloadBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const loadVendors = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/vendors`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getVendors(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const deleteVendor = (id) => {
    return function (dispatch) {
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/vendor_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delelte(types.DELETE_VENDORS));
                notifysuccess(res.data.message)
                dispatch(loadVendors());
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const editStatusVendorr = (id, is_active, setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        console.log(id)
        console.log(is_active)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/vendor_status`, { id, is_active }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editStatueVendor());
                dispatch(loadVendors());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data)
        })
    }
}

export const loadOneVendor = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/vendor?id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getOneVendor(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}
export const emptyOneVen = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_ONE_VENDOR))
    }
}


export const updateVendor = (id, name, name_ar, description, description_ar, phone, phone1, email, address, address1, start_date,
    expire_date, image, custom_date, subcategories, latitude, longitude, days, social_media, category_id, setloadBtn
) => {
    return function (dispatch) {
        setloadBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        if (image !== '') {
            Dataa.append('image', image);
        }
        Dataa.append('id', id);
        Dataa.append('name', name);
        Dataa.append('name_ar', name_ar);
        Dataa.append('description', description);
        Dataa.append('description_ar', description_ar);
        Dataa.append('phone', phone);
        Dataa.append('phone1', phone1);
        Dataa.append('email', email);
        Dataa.append('address', address);
        Dataa.append('address1', address1);
        Dataa.append('start_date', start_date);
        Dataa.append('expire_date', expire_date);
        Dataa.append('custom_date', custom_date);
        Dataa.append('latitude', latitude);
        Dataa.append('longitude', longitude);
        Dataa.append('category_id', category_id);
        if (subcategories.length !== 0) {
            for (var i = 0; i < subcategories.length; i++) {
                Dataa.append(`subcategories[${i}]`, subcategories[i]);
            }
        }
        if (days.length !== 0) {
            days.forEach((field, index) => {
                Dataa.append(`days[${index}][day_id]`, field.dayId);
                Dataa.append(`days[${index}][open_at]`, field.openAt);
                Dataa.append(`days[${index}][close_at]`, field.closeAt);
            });
        }
        if (social_media.length !== 0) {
            social_media.forEach((field, index) => {
                Dataa.append(`social_media[${index}][id]`, field.socId);
                Dataa.append(`social_media[${index}][link]`, field.link);
            });
        }
        axios.post(`${staticc}/api/vendor_update`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editVendor());
                dispatch(loadVendors());
                notifysuccess(res.data.message)
                setloadBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const deleteDayVendor = (vendor_id,day_id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/delete-day`, { vendor_id,day_id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delelte(types.DELETE_DAY_VENDOR));
                notifysuccess(res.data.message)
                dispatch(loadOneVendor(vendor_id));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const deleteSocialVendor = (id,vendor_id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.delete(`${staticc}/api/social-media-delete?id=${id}&vendor_id=${vendor_id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delelte(types.DELETE_SOCIAL_VENDOR));
                notifysuccess(res.data.message)
                dispatch(loadOneVendor(vendor_id));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}